<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ info.storeName }}</h1>
    </div>
    <b-card>
      <b-row class="gx-2">
        <b-col md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.storeName"
          >
          </MenuInner>
        </b-col>
        <b-col md="10">
          <div>
            <h3>Lịch sử gán</h3>
            <b-table
              hover
              sticky-header
              responsive
              :items="historyConfig"
              :fields="fieldsConfig"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
              style="margin-top: 10px"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #cell(staffAssignId)="{ item, value }">
                <div>{{ getStaffName(value) }}</div>
                <div>
                  <span class="text-muted">Loại</span>:
                  {{ item.configType == 'MAIN' ? 'Chính' : 'Phụ' }}
                </div>
              </template>
              <template #cell(time)="{ item }">
                <div v-if="item.creator">
                  <span class="text-muted">Người duyệt phiếu</span>:
                  {{ item.creator?.name }}
                </div>
                <div v-if="item.createdTime">
                  <span class="text-muted">Thời gian duyệt phiếu</span>:
                  {{ formatDate(item.createdTime) }}
                </div>
              </template>
              <template #cell(creator)="{ item }">
                <div v-if="item.createdAssignOrderName">
                  <span class="text-muted">Người tạo phiếu</span>:
                  {{ item.createdAssignOrderName }}
                </div>
                <div v-if="item.createdAssignOrderDate">
                  <span class="text-muted">Thời gian tạo phiếu</span>:
                  {{ formatDate(item.createdAssignOrderDate) }}
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { historyAssign } from '@/services/customer-support/store-staff'
  import { Detail } from '@/services/customer-support/store'
  import { showMess } from '@/config/utils'
  import moment from 'moment'
  import { asignType } from '@/pages/customer-support/cskh/account/components/constant'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner.vue'
  import { DetailMenus } from '@/pages/customer-support/cskh/store/components/constant'

  export default {
    name: 'HistoryAssignStore',
    components: { MenuInner },
    data() {
      return {
        DetailMenus,
        isLoading: false,
        activeItem: 'lich_su_gan',
        id: '',
        info: [],
        historyAssign: [],
        historyConfig: [],
        fieldsAssign: [],
        fieldsConfig: [
          {
            key: 'staffAssignId',
            label: 'Nhân viên chăm sóc',
            sortable: false,
            thStyle: 'width: 100px; text-align: center',
          },
          {
            key: 'creator',
            label: 'Người/Thời gian tạo phiếu gán',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
          {
            key: 'time',
            label: 'Người/Thời gian duyệt phiếu gán',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
        ],
        asignType,
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
      this.level = 'STORE'
    },
    mounted() {
      // if (this.dataPermission.includes('CNPS_CSS_MA_DETAIL')) {
      this.getHistoryAssign()
      this.toggleSideBar()
      this.GetDetail()
      // } else {
      //   this.$bvModal.msgBoxOk('Bạn không có quyền truy cập vào trang này', {
      //     title: 'Cảnh báo',
      //     // size: 'sm',
      //     // buttonSize: 'sm',
      //     okVariant: 'danger',
      //     headerClass: 'p-2 border-bottom-0',
      //     footerClass: 'p-2 border-top-0',
      //     centered: true,
      //   })
      //     .then(value => {
      //       // chuyển trang
      //       this.$router.replace('/');
      //     })
      // }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStaffName() {
        return staffId => {
          const uInfo = this.historyAssign[staffId] ?? undefined
          return uInfo
            ? `${uInfo.staffName} - ${uInfo.staffTypes.map(type => this.asignType[type]).join(', ')}`
            : staffId
        }
      },
    },
    methods: {
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      async getHistoryAssign() {
        try {
          this.isLoading = true
          const res = await historyAssign({
            assignmentId: this.id,
            level: this.level,
          })
          this.historyAssign = res.data.logAssigns.reduce((map, item) => {
            map[item.id] = item
            return map
          }, [])
          this.historyConfig = res.data?.logHistoryConfigs.filter(item => item.type !== 'REMOVE')
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      async GetDetail() {
        try {
          const res = await Detail(this.id)
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
        }
      },
    },
  }
</script>

<style scoped></style>
